<template lang="pug">
  .WelcomePage
    LoadingCover(
      v-if="loading"
      :fullscreen="true"
    )
    template(v-else)
      .info(v-if="date") Güncelleme Tarihi: {{ date }}
      .action-container.full
        .week-selector
          .left(
            @click="changeWeek(1)"
          ) <
          .week {{ selectedWeek }}
          .right(
            :class="{'disabled': weekChange === 0}"
            @click="changeWeek(-1)"
          ) >

      Progress(
        type="price"
        :title="'MRR'"
        :start="lastWeekMRR"
        :current="currentMRR"
        :ratio="ratio"
        :week="selectedWeek"
      )
      Progress(
        :title="'Müşteri'"
        :start="lastWeekCustomer"
        :current="currentCustomer"
        :ratio="ratio"
        :week="selectedWeek"
      )

      .action-container.full.sticky
        .toggle-box
          .toggle(v-for="dateRange in dateRanges"
            :class="{'active': dateRange.id === activeDateRange}"
            @click="onDateRangeSelect(dateRange)"
          )
            name {{ dateRange.name }}

      MRRChangeChart.full(
        :data="mergedMRRTotalsList.slice(1)"
        :dateList="dateList"
      )
      TotalMRRSubTypeChart.full(
        :data="mergedMRRTotalsList.slice(1)"
      )
      CustomerChangeChart.full(
        :data="mergedCustomerList.slice(1)"
      )
      TotalACVChart.full(
        :data="mergedMRRTotalsList.slice(1)"
        :customer_data="mergedCustomerList.slice(1)"
      )
      TotalACVChartByMonth.full(
        :data="mergedMRRTotalsList.slice(1)"
        :customer_data="mergedCustomerList.slice(1)"
      )
      // TotalMRRChart(
      //   :data="mergedMRRTotalsList"
      //   :ratio="totalRatio"
      // )
      // TotalCustomerMRRChart(
      //   :data="mergedCustomerList"
      //   :ratio="totalRatio"
      // )
      // TotalLicencesChart.full(
      //   :data="mergedSubTotalsList.slice(1)"
      // )

</template>

<script>
import moment from 'moment'
import MRRChangeChart from './components/mrr-change-chart'
import CustomerChangeChart from './components/customer-change-chart'
import TotalLicencesChart from './components/total-licences-chart'
import TotalMRRSubTypeChart from './components/total-mrr-sub-type-chart'
import TotalMRRChart from './components/total-mrr-chart'
import TotalCustomerMRRChart from './components/total-customer-chart'
import TotalACVChart from './components/total-acv-chart'
import TotalACVChartByMonth from './components/total-acv-chart-by-month'
import Progress from './components/progress'
import SimpleProgress from './components/simple-progress'
import { mapActions, mapState } from "vuex";
import { mapDateUtils } from '@/utils/date-utils'
import { CustomerCountModel, MRRModel, SubTypeModel } from '@/model/Welcome'
import _forEach from 'lodash/forEach'


export default {
    name: 'Welcome',
    components: {
      MRRChangeChart,
      CustomerChangeChart,
      TotalLicencesChart,
      TotalMRRSubTypeChart,
      TotalMRRChart,
      TotalCustomerMRRChart,
      TotalACVChart,
      TotalACVChartByMonth,
      Progress,
      SimpleProgress
    },

    data () {
      return {
        ratio: 10,
        loading: false,
        activeDateRange: 'week',
        dateRanges: [
          {
            id: 'week',
            name: "Haftalık"
          },
          {
            id: 'month',
            name: "Aylık"
          },
        ],
        lastWeekMRR: 0,
        currentMRR: 0,
        lastWeekCustomer: 0,
        currentCustomer: 0,
        weekChange: 0,

        mergedCustomerList: [],
        mergedSubTotalsList: [],
        mergedMRRTotalsList: [],
      }
    },

    async created () {
      await this.fetchData()
    },

    watch: {
      weekChange () {
        this.updateGoals()
      },
    },

    computed: {
      ...mapState('Welcome', [
        'welcomeExpenseAndIncomeData',
        'welcomeBudgetCompareData',
        'customerChangeList',
        'subTotalsList',
        'mrrList',
        'date'
      ]),

      dateList () {
        let dateList = []
        if (this.activeDateRange === 'week') {
          this.getLastNWeeks(13).forEach(d => {
            dateList.push([
              d[0].format('YYYY-MM-DD'),
              d[1].format('YYYY-MM-DD'),
              d[0].format('W') + '. Hafta ' + d[0].format('\'YY'),
            ])
          })
        } else {
          this.getLastNMonths(13).forEach(d => {
            dateList.push([
              d[0].format('YYYY-MM-DD'),
              d[1].format('YYYY-MM-DD'),
              d[0].format('MMMM \'YY'),
            ])
          })
        }
        return dateList
      },

      selectedWeek () {
        return moment().subtract(this.weekChange, 'week').startOf('week').format('W') + '. Hafta'
      },

      totalRatio () {
        if (this.activeDateRange === "week")
          return this.ratio
        else
          return (Math.pow((100 + this.ratio) / 100, 4) - 1) * 100
      }
    },

    methods: {
      ...mapActions('Welcome', [
        'fetchWelcomeGeneral',
        'fetchWelcomeDetail',
        'fetchWelcomeExpenseIncome',
        'fetchWelcomeBudgetCompare'
      ]),

      ...mapDateUtils([
        'getLastNWeeks',
        'getLastNMonths',
        'getCurrentWeek'
      ]),

      onDateRangeSelect (dateRange) {
        this.activeDateRange = dateRange.id
        this.loadData()
      },

      getMergedCustomerList () {
        let merged_data = []
        let dateList = this.dateList
        let dateIndex = 0

        let currentCustomerData = new CustomerCountModel({
          stat_date: dateList[0][2]
        })

        merged_data = this.dateList.map(d => new CustomerCountModel({
          stat_date: d[2]
        }))

        _forEach(this.customerChangeList, c => {
          if (c.stat_date >= dateList[dateIndex][0] && c.stat_date <= dateList[dateIndex][1]) {
            currentCustomerData.add(c)
          } else if (c.stat_date >= dateList[dateIndex][1]) {
            merged_data[dateIndex] = currentCustomerData

            dateIndex++
            currentCustomerData = new CustomerCountModel({
              ...c,
              stat_date: dateList[dateIndex][2]
            })
          }
        })

        for (let i = dateIndex; i < dateList.length; i++) {
          if (i > dateIndex) {
            currentCustomerData = new CustomerCountModel({
              ...currentCustomerData,
              new: 0,
              churn: 0,
              net: 0,
              stat_date: dateList[i][2]
            })
          }
          merged_data[i] = currentCustomerData
        }

        return merged_data
      },

      getMergedSubTotalsList () {
        let merged_data = []
        let dateList = this.dateList
        let dateIndex = 0

        let prevSubData = new SubTypeModel({
          stat_date: dateList[0][2]
        })

        merged_data = this.dateList.map(d => new SubTypeModel({
          stat_date: d[2]
        }))

        _forEach(this.subTotalsList, c => {
          if (c.stat_date >= dateList[dateIndex][0] && c.stat_date <= dateList[dateIndex][1]) {
            prevSubData = c

          } else if (c.stat_date >= dateList[dateIndex][1]) {
            prevSubData = new SubTypeModel({
              ...prevSubData,
              stat_date: dateList[dateIndex][2]
            })

            merged_data[dateIndex] = prevSubData

            dateIndex++
            prevSubData = c
          }
        })

        let lastSubData = new SubTypeModel({
          ...prevSubData,
          stat_date: dateList[dateIndex][2]
        })

        for (let i = dateIndex; i < dateList.length; i++) {
          if (i > dateIndex) {
            lastSubData = new SubTypeModel({
              ...lastSubData,
              stat_date: dateList[i][2]
            })
          }
          merged_data[i] = lastSubData
        }

        return merged_data
      },

      getMergedMRRTotalsList () {
        let merged_data = []
        let dateList = this.dateList
        let dateIndex = 0

        let currentMRRData = new MRRModel({
          stat_date: dateList[0][2]
        })

        merged_data = this.dateList.map(d => new MRRModel({
          stat_date: d[2]
        }))

        _forEach(this.mrrList, c => {
          if (c.stat_date >= dateList[dateIndex][0] && c.stat_date <= dateList[dateIndex][1]) {
            currentMRRData.sub_types_total = c.sub_types_total
            currentMRRData.total_mrr = c.total_mrr
            _forEach(c.types, pt => {
              currentMRRData.types_dict[pt.payment_type].mrr.add(pt.mrr)
            })
          } else if (c.stat_date >= dateList[dateIndex][1]) {
            merged_data[dateIndex] = new MRRModel({
              ...currentMRRData,
            })

            dateIndex++

            currentMRRData = new MRRModel({
              ...c,
              stat_date: dateList[dateIndex][2]
            })
          }
        })

        let lastMrrData = new MRRModel({
          ...currentMRRData,
          stat_date: dateList[dateIndex][2]
        })

        for (let i = dateIndex; i < dateList.length; i++) {
          if (i > dateIndex) {
            lastMrrData = new MRRModel({
              ...currentMRRData,
              types: [],
              stat_date: dateList[i][2]
            })
          }
          merged_data[i] = lastMrrData
        }

        return merged_data
      },

      loadData () {
        this.mergedCustomerList = this.getMergedCustomerList()
        this.mergedSubTotalsList = this.getMergedSubTotalsList()
        this.mergedMRRTotalsList = this.getMergedMRRTotalsList()
      },

      async fetchData () {
        this.loading = true
        try {
          await this.fetchWelcomeGeneral()
          this.updateGoals()
          this.loadData()
        } finally {
          this.loading = false
        }
      },

      changeWeek (amount) {
        this.weekChange += amount
      },

      updateGoals () {
        let weekStart = moment().subtract(this.weekChange, 'week').startOf('week').format('YYYY-MM-DD')
        let nextWeekStart = moment().subtract(this.weekChange - 1, 'week').startOf('week').format('YYYY-MM-DD')

        let hasNext = false
        for (let i = this.mrrList.length - 1; i >= 0; i--) {
          if (this.mrrList[i].stat_date < nextWeekStart && !hasNext) {
            this.currentMRR = this.mrrList[i].total_mrr.total
            hasNext = true
          }

          if (this.mrrList[i].stat_date < weekStart) {
            this.lastWeekMRR = this.mrrList[i].total_mrr.total
            break
          }
        }

        hasNext = false
        for (let i = this.customerChangeList.length - 1; i >= 0; i--) {
          if (this.customerChangeList[i].stat_date < nextWeekStart && !hasNext) {
            this.currentCustomer = this.customerChangeList[i].total
            hasNext = true
          }

          if (this.customerChangeList[i].stat_date < weekStart) {
            this.lastWeekCustomer = this.customerChangeList[i].total
            break
          }
        }
      }

    }

  }
</script>

<style lang="scss" scoped>
  .WelcomePage {
    position: relative;
    min-height: calc(100vh - 80px);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 30px;
    margin-left: auto;
    margin-right: auto;
    max-width: 1200px;

    .info {
      font-weight: 400;
      font-size: 13px;
      color: $color-gray-500;
    }

    .title {
      font-weight: 500;
      font-size: 16px;
    }

    .full {
      grid-column: 1/3;
    }

    .action-container {
      display: flex;
      align-items: center;
      justify-content: center;

      &.sticky {
        position: sticky;
        z-index: 99;
        top: 0;
      }

      .week-selector {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        border-radius: 8px;
        transition: all $transition-slow;
        user-select: none;
        border: 1px solid $color-gray-300;
        box-shadow: 0 18px 32px rgba(18, 78, 119, 0.3);

        .week {
          padding: 12px 18px;
          color: $color-navy-300;

        }

        .left, .right {
          padding: 12px 18px;
          cursor: pointer;

          &.disabled {
            color: $color-gray-300;
            pointer-events: none;
          }

          &:hover {
            background-color: $color-gray-200;
          }
        }
      }

      .toggle-box {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid $color-gray-300;
        box-shadow: 0 18px 32px rgba(18, 78, 119, 0.3);

        .toggle {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 12px;
          min-width: 150px;
          background-color: $color-gray-200;
          color: $color-gray-600;
          cursor: pointer;
          transition: all $transition-slow;
          user-select: none;
          border-bottom: 4px solid transparent;

          &.active {
            color: $color-navy-500;
            background-color: white;
            border-bottom: 4px solid $color-blue-600;
          }

          &:hover {
            background-color: $color-gray-300;
          }
        }
      }

    }


    @media screen and (max-width: 960px) {
      grid-template-columns: 1fr;
    }

    /deep/ {
      .box {
        background-color: white;
        border-radius: 16px;
        padding: 20px;
      }

      .apexcharts-bar-area {
        stroke: none;
      }
    }
  }
</style>
